var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.6 33.7",
    style: {
      enableBackground: "new 0 0 35.6 33.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E17726;stroke:#E17726;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#E27625;stroke:#E27625;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#D5BFB2;stroke:#D5BFB2;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#233447;stroke:#233447;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#CC6228;stroke:#CC6228;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#E27525;stroke:#E27525;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#F5841F;stroke:#F5841F;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#C0AC9D;stroke:#C0AC9D;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#161616;stroke:#161616;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#763E1A;stroke:#763E1A;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,1l-13.1,9.7L22.3,5L33,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.7,1l13,9.8L13.4,5L2.7,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,23.5l-3.5,5.3l7.5,2.1l2.1-7.3L28.3,23.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,23.7l2.1,7.3l7.5-2.1l-3.5-5.3L1.3,23.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,14.5l-2.1,3.1l7.4,0.3l-0.2-8L10.5,14.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2,14.5l-5.2-4.6L19.9,18l7.4-0.3L25.2,14.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.9,28.9l4.5-2.2l-3.9-3L10.9,28.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.3,26.7l4.5,2.2l-0.6-5.2L20.3,26.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.8,28.9l-4.5-2.2l0.4,2.9l0,1.2L24.8,28.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,28.9l4.2,2l0-1.2l0.4-2.9L10.9,28.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.2,21.8l-3.7-1.1l2.6-1.2L15.2,21.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.6,21.8l1.1-2.3l2.6,1.2L20.6,21.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.9,28.9l0.6-5.3l-4.1,0.1L10.9,28.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.2,23.5l0.6,5.3l3.5-5.2L24.2,23.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.3,17.7L19.9,18l0.7,3.8l1.1-2.3l2.6,1.2L27.3,17.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.5,20.7l2.6-1.2l1.1,2.3l0.7-3.8l-7.4-0.3L11.5,20.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.5,17.7l3.1,6.1l-0.1-3L8.5,17.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.3,20.7l-0.1,3l3.1-6.1L24.3,20.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.9,18l-0.7,3.8l0.9,4.5l0.2-5.9L15.9,18z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.9,18l-0.4,2.4l0.2,5.9l0.9-4.5L19.9,18z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.6,21.8l-0.9,4.5l0.6,0.4l3.9-3l0.1-3L20.6,21.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M11.5,20.7l0.1,3l3.9,3l0.6-0.4l-0.9-4.5L11.5,20.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.7,30.9l0-1.2l-0.3-0.3h-5l-0.3,0.3l0,1.2l-4.2-2l1.5,1.2l2.9,2h5.1l3-2l1.4-1.2L20.7,30.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M20.3,26.7l-0.6-0.4H16l-0.6,0.4l-0.4,2.9l0.3-0.3h5l0.3,0.3L20.3,26.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M33.6,11.4L34.7,6L33,1l-12.7,9.4l4.9,4.1l6.9,2l1.5-1.8L33,14.3l1.1-1l-0.8-0.6l1.1-0.8L33.6,11.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1.1,6l1.1,5.4l-0.7,0.5l1.1,0.8l-0.8,0.6l1.1,1l-0.7,0.5l1.5,1.8l6.9-2l4.9-4.1L2.7,1L1.1,6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.1,16.5l-6.9-2l2.1,3.1l-3.1,6.1l4.1-0.1h6.1L32.1,16.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.5,14.5l-6.9,2l-2.3,7.1h6.1l4.1,0.1l-3.1-6.1L10.5,14.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19.9,18l0.4-7.6l2-5.4h-8.9l2,5.4l0.4,7.6l0.2,2.4l0,5.9h3.7l0-5.9L19.9,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask_icon.bef0fa07dba1cee72edbd6f5fbb522e1.svg";
export { ForwardRef as ReactComponent };